import { configure } from 'mobx'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from '@/app/App'
import { i18n } from '@/i18n'
import { reloadForNewVersion } from '@/lib/chunkReload'
import { initSentry, sentryRootOptions } from '@/lib/sentry'
import './index.css'

configure({ enforceActions: 'observed' })

// First, so errors during boot are reported too.
initSentry()

// Vite reports a failed chunk preload (the deploy replaced it); reload onto the new build.
window.addEventListener('vite:preloadError', (event) => {
  if (reloadForNewVersion()) event.preventDefault()
})

// Only the active language is fetched; render once its dictionary is in memory.
void i18n.ready().then(() =>
  createRoot(document.getElementById('root')!, sentryRootOptions).render(
    <StrictMode>
      <App />
    </StrictMode>,
  ),
)
